const projects = [
  {
    Name: 'DBpedia',
    StudentsContact: 'Anand Panchbhai, panchbhai1969 ; Shivendu, KShivendu ;',
    Description:
      'DBpedia is a project aiming to extract structured content from the information created in the Wikipedia project.',
    TechStack: ' Java, Python, Scala, JavaScript, Shell',
    Link: 'https://github.com/dbpedia/',
  },
  {
    Name: 'Haiku',
    StudentsContact: 'Yatendra, yatendra1999;',
    Description:
      'An open-source operating system that specifically targets personal computing.',
    TechStack: ' C, Shell, Rust, HTML, Go',
    Link: 'https://github.com/haiku',
  },
  {
    Name: 'FFmpeg',
    StudentsContact: 'Yatendra, yatendra1999;',
    Description:
      'FFmpeg is the leading multimedia framework, able to decode, encode, transcode, mux, demux, stream, filter and play pretty much anything that humans and machines have created.',
    TechStack: ' Perl, C, Shell, CSS, Dockerfile',
    Link: 'https://github.com/FFmpeg',
  },
  {
    Name: 'Ignitus',
    StudentsContact: 'Meghana Varanasi, Meghana-12;',
    Description:
      'Ignitus a non-profit organization that helps students and professionals get handpicked top quality global research and industrial internships, for free!',
    TechStack: ' JavaScript, C++, Python, TypeScript, HTML',
    Link: 'https://github.com/Ignitus/',
  },
  {
    Name: 'Free Code Camp',
    StudentsContact: 'Ambar Mutha, supercoww;',
    Description:
      'Platform to learn to code for free with millions of other people around the world',
    TechStack: 'JavaScript, React, Gatsby, CSS',
    Link: 'https://github.com/freeCodeCamp/',
  },
  {
    Name: 'IBM/EVOTE',
    StudentsContact: 'Pratik Sanjay Patil, pratikpatil024',
    Description:
      'A voting application that leverages Hyperledger Fabric and the IBM Blockchain Platform to record and tally ballots.',
    TechStack: 'NODE.JS, VUE.JS, Blockchain Platform: Hyperledger Fabric',
    Link: 'https://github.com/IBM/evote',
  },
];

export default projects;
